import { Link } from 'react-router-dom';
import { categories } from '@/mocks/siteData';

interface ArticleCardProps {
  slug: string;
  title: string;
  category: string;
  excerpt: string;
  readTime: number;
  imageUrl: string;
  publishedAt: string;
}

export default function ArticleCard({ slug, title, category, excerpt, readTime, imageUrl, publishedAt }: ArticleCardProps) {
  const catInfo = categories.find(c => c.slug === category);
  const catName = catInfo?.name || category;

  return (
    <article className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden transition-all duration-300 hover:border-primary-200 cursor-pointer">
      <Link to={`/article/${slug}`} className="block">
        <div className="relative w-full aspect-[5/3] overflow-hidden">
          <img
            src={imageUrl}
            alt={title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            title={title}
          />
        </div>
        <div className="p-4 md:p-5">
          <div className="flex items-center gap-2 mb-2">
            <span className="text-xs px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 whitespace-nowrap">
              {catName}
            </span>
            <span className="text-xs text-foreground-400 whitespace-nowrap">{readTime} 分钟阅读</span>
          </div>
          <h3 className="text-base md:text-lg font-semibold font-heading text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
            {title}
          </h3>
          <p className="text-sm text-foreground-500 line-clamp-2 leading-relaxed">
            {excerpt}
          </p>
          <div className="mt-3 flex items-center justify-between">
            <time dateTime={publishedAt} className="text-xs text-foreground-400">
              {publishedAt}
            </time>
            <span className="text-xs text-primary-500 font-medium flex items-center gap-1 whitespace-nowrap">
              阅读全文 <i className="ri-arrow-right-line text-xs"></i>
            </span>
          </div>
        </div>
      </Link>
    </article>
  );
}